import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=2d6a0cd8&scoped=true"
import script from "./MainList.vue?vue&type=script&lang=js"
export * from "./MainList.vue?vue&type=script&lang=js"
import style0 from "./MainList.vue?vue&type=style&index=0&id=2d6a0cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a0cd8",
  null
  
)

export default component.exports